import React, { Component } from "react";
import { shuffle, filter } from "lodash";

//-----------------------------------------------------------------------------
// Multiple Choice Question Type - MCH
//-----------------------------------------------------------------------------
class MCHTypeQuestion extends Component {
  constructor() {
    super();
    this.state = {
      generatedAnswers: [],
    };
  }

  componentDidMount() {
    const { currentQuestion } = this.props;
    this.generateAnswersSet(
      currentQuestion.AData,
      currentQuestion.IsRandomAnswers,
      currentQuestion.QTypeShort,
      currentQuestion.ADataRandomLines
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentQuestion !== nextProps.currentQuestion) {
      this.generateAnswersSet(
        nextProps.currentQuestion.AData,
        nextProps.currentQuestion.IsRandomAnswers,
        nextProps.currentQuestion.QTypeShort,
        nextProps.currentQuestion.ADataRandomLines
      );
    }
  }

  generateAnswersSet = (
    answerData,
    isRandomAnswers,
    questionType,
    randomLinesCount
  ) => {
    let generatedAnswersArray = [];
    generatedAnswersArray = filter(answerData.split("\n")).map(
      (item, index) => {
        let splittedArray = item.split("|");
        return splittedArray[0] !== ""
          ? {
              id: index + 1,
              answerValue: splittedArray[0],
              answerText: splittedArray[1],
            }
          : null;
      }
    );

    generatedAnswersArray = this.props.getRandomAnswersWithSingleCorrect(
      filter(generatedAnswersArray),
      randomLinesCount
    );

    if (isRandomAnswers === "1") {
      generatedAnswersArray = shuffle(generatedAnswersArray);
    }
    this.setState({
      generatedAnswers: generatedAnswersArray,
    });
  };

  onClickMCHAnswer = (answer) => {
    let { currentQuestion, currentQuestionId } = this.props;

    let questionDetails = {
      number: currentQuestionId,
      questionText: currentQuestion.QLong,
      QTypeShort: currentQuestion.QTypeShort,
      questionGraphicUrl: currentQuestion.QGraphicURL,
      expectedAnswerText: "",
      givenAnswerText: answer.answerText,
      isCorrect: answer.answerValue === "T" ? 1 : 0,
    };
    this.props.addAttendedQuestion(questionDetails);
  };

  render() {
    const { generatedAnswers } = this.state;

    return (
      <div className="answer-options-container">
        {generatedAnswers.map((item, itemIndex) => {
          return (
            <div
              className={"single-answer-block is-mch-option"}
              key={"answer_" + itemIndex}
              onClick={() => {
                this.onClickMCHAnswer(item);
              }}
            >
              {item.answerText}
            </div>
          );
        })}
      </div>
    );
  }
}

export default MCHTypeQuestion;
